module.exports = __webpack_public_path__ + "static/media/cube_texture_rubk.06f0b7c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/images/cube_texture_rubk.png
// module id = 1621
// module chunks = 0